import $ from "jquery";
import ReactDOM from "react-dom";
import { Fragment, useCallback, useContext, useEffect, useState } from "react";
import { axiosInstance } from "../../axios/axiosInstance";
import { GlobalContext } from "../../Context/GlobalContext";
import { WishlistItem } from "./addWhistList";
import { useGlobalFunction } from "../../Context/GlobalFunctionContext";
import { useAuth } from "../../Context/AuthContext";
import { QuantityStripper } from "./quantityStripper";
import { ConvertToFloat } from "./common";
import { ImageWithDefault } from "./imageWithDefault";
import { ToolbarContainer } from "../../View/ProductHybrid/toolbarContainer";
import { ProductStockStatusContainer } from "./productStockStatusContainer";
import { contructProductData } from "./algoliaInstantLib";
import { useOpenProduct } from "../../View/ProductHybrid/productPageOverlay/overlayNavigation";
import { ProductLink } from "./productLink";

export const ProductCardAlgoliaList = ({ data, index }) => {
  const globalcontext = useContext(GlobalContext);
  const [PriceTabelData, setPriceTabelData] = useState(null);
  const [productStock, setProductStock] = useState(null);
  const [productPrice, setProductPrice] = useState(null);
  const [ProductData, setProductData] = useState(null);
  const [isAdded, setIsadded] = useState(false);
  const [qty, setQty] = useState({});
  const { userId, eBayBlock } = useAuth();
  const [product, setProduct] = useState(null);
  const [cartItem, setCartItem] = useState(null);
  const [cartParams, setCartParams] = useState(null);
  const { getProductPrice, getStockStatus } = useGlobalFunction();
  const [stockStatusRaw, setstockStatusRaw] = useState(null);

  useEffect(() => {
    if (data && data.productId) {
      setProduct(data);
      let _prd = contructProductData(data);
      setProductData(_prd);
      //console.log("data.contructProductData=", contructProductData(data));
      setstockStatusRaw(data.messageToDisplay);
      //fetchStockStatus(data.productId);
      setQty({ prod_id: data.productId, qty: 1 });
      setProductPrice(ConvertToFloat(data.price));
      setCartItem(data);
      if (_prd) {
        setCartParams({
          code: _prd.sku,
          desc: _prd.description,
          img: _prd.prodImage,
        });
      }
    }
  }, [data]);

  useEffect(() => {
    if (
      globalcontext.CartItem &&
      globalcontext.CartItem.cartItem &&
      globalcontext.CartItem.cartItem.length > 0 &&
      data
    ) {
      var products = globalcontext.CartItem.cartItem;
      var filterProductId = products.find((item) => String(item.prod_id) == String(data.productId));
      setIsadded(!!filterProductId);
      if (filterProductId)
        setQty({
          prod_id: data.productId,
          qty: filterProductId.qty ?? 1,
        });

      setCartItem({
        prod_id: data.productId,
        qty: filterProductId && filterProductId.qty ? filterProductId.qty : 0,
      });
    } else {
      setIsadded(false);
      setQty({ prod_id: data.productId, qty: 1 });
      setCartItem({
        prod_id: data.productId,
        qty: 0,
      });
    }
  }, [globalcontext.CartItem]);

  return (
    <Fragment>
      {ProductData && (
        <div className="row" data-id={ProductData.productId}>
          <div className="col-md-12 col-lg-7">
            <div className="row">
              <div className="col-md-3 col-lg-3 row-pro-img">
                <ProductLink to={ProductData.link}>
                  <ImageWithDefault
                    src={ProductData.prodImage}
                    classList="img-fluid"
                    alt="product image"
                    style={{ maxHeight: "138px" }}
                  />
                </ProductLink>
              </div>
              <div className="col-md-9 col-lg-9">
                <h6 className="product-title">
                  <ProductLink to={ProductData.link}>{ProductData.description}</ProductLink>
                  {ProductData.isClearance ? (
                    <small className="product-stage new-clearance">CLEARANCE</small>
                  ) : (
                    ProductData.isNew && <small className="product-stage new-product">New</small>
                  )}
                </h6>
                <div className="row-product-features product-features">
                  {!ProductData.isSubstitute && !ProductData.isUnavailable && !ProductData.isDiscontinued ? (
                    <div className="product-features maxDescription-4">
                      <p>{ProductData.desc}</p>
                    </div>
                  ) : ProductData.isSubstitute ? (
                    <ProductReplacementDesc item={ProductData} />
                  ) : (
                    <ProductUnavailableDesc item={ProductData} />
                  )}
                </div>
              </div>
            </div>
          </div>
          <div className="col-md-12 col-lg-5 text-end row-productListing">
            {ProductData.isfamily ? (
              <ProductFamily item={ProductData} productPrice={PriceTabelData} stockStatus={productStock} />
            ) : ProductData.isSubstitute ? (
              <ProductReplacementAction item={ProductData} />
            ) : ProductData.isDiscontinued || ProductData.isUnavailable ? (
              <ProductUnavailableAction item={ProductData} />
            ) : (
              <Fragment>
                <div className="row-price">
                  <p>${ConvertToFloat(ProductData.price)}</p>
                </div>
                <div className="product-code-availability">
                  <span>Code: {ProductData.sku}</span>{" "}
                  <span className="proAvailablity">
                    Availability:
                    {/*{productStock != null ? (*/}
                    {/*  <ProductStockStatusContainer params={productStock} />*/}
                    {/*) : (*/}
                    {eBayBlock && ProductData.eBayBlock ? (
                      " UNAVAILABLE"
                    ) : (
                      <span className="cc-pro-available" style={{ color: "#1abc79", fontWeight: "bold" }}>
                        {" "}
                        {ProductData.messageToDisplay}
                      </span>
                    )}
                    {/*)}*/}
                  </span>
                </div>

                <div className="row-products-info">
                  <div className="product-adding-icons rowProducts-addingIcons">
                    <ToolbarContainer product={ProductData} cartItem={cartItem} showPriceTable={true} />
                  </div>
                  {/*  {productStock && productStock.isShowBuy ==true && (*/}
                  {eBayBlock && ProductData.eBayBlock ? (
                    <div style={{ textAlign: "left" }}>
                      <p className="text-danger">This product is not available for purchase.</p>
                    </div>
                  ) : (
                    <div className="rowProduct-btns listView-btn-correction">
                      <QuantityStripper prd={cartItem} params={cartParams} wrapperClass="flex-nowrap" />
                    </div>
                  )}
                  {/*)}*/}
                </div>
              </Fragment>
            )}
          </div>
        </div>
      )}
    </Fragment>
  );
};

const ProductReplacementDesc = ({ item }) => {
  return (
    <Fragment>
      <div className="product-unavailable">
        <p>Substituted</p>
      </div>
      <div className="product-code product-substituted">
        <p>
          Replacement:
          <ProductLink to={item.wesSubstituteUrl}>{item.productSubstitute}</ProductLink>
        </p>
      </div>
    </Fragment>
  );
};

const ProductReplacementAction = ({ item }) => {
  return (
    <Fragment>
      <div className="row-products-info">
        <div className="rowProduct-btns" style={{ display: "block" }}>
          <div className="product-button">
            <button type="button" className="btn btn-products btn-unavailable">
              Unavailable
            </button>
          </div>
        </div>
      </div>
    </Fragment>
  );
};

const ProductUnavailableDesc = ({ item }) => {
  return (
    <Fragment>
      {item.isDiscontinued ? (
        <div className="product-unavailable">
          <p>Discontinued</p>
        </div>
      ) : (
        <div className="product-unavailable">
          <p>Temporarily Unavailable</p>
        </div>
      )}
    </Fragment>
  );
};

const ProductUnavailableAction = ({ item }) => {
  return (
    <Fragment>
      <div className="row-products-info">
        <div className="rowProduct-btns" style={{ display: "block" }}>
          <div className="product-button button-effect">
            <button type="submit" className="btn btn-products btn-unavailable">
              Discontinued
            </button>
          </div>
        </div>
      </div>
    </Fragment>
  );
};

const ProductFamily = ({ item, productPrice, stockStatus }) => {
  const { isAuthenticated } = useAuth();
  const openProduct = useOpenProduct(isAuthenticated === true);
  return (
    <Fragment>
      <div className="row-price">
        <p>{item.hidePrice ? "" : `$ ${ConvertToFloat(item.price)}`}</p>
      </div>
      <div className="row-products-info">
        <div className="rowProduct-btns">
          <div className="product-button button-effect">
            <button type="button" onClick={() => openProduct(item.link)} className="btn btn-products btn-buying">
              <span className="wes-buying-option" />
              <span className="btn-options">Buying Options</span>
            </button>
          </div>
        </div>
      </div>
    </Fragment>
  );
};
